export default __webpack_public_path__ + "static/media/Icon_vedi_eliminato.77c10f4d.svg";